import { render, staticRenderFns } from "./statisticsDetails.vue?vue&type=template&id=3094d77d&scoped=true"
import script from "./statisticsDetails.vue?vue&type=script&lang=js"
export * from "./statisticsDetails.vue?vue&type=script&lang=js"
import style0 from "./statisticsDetails.vue?vue&type=style&index=0&id=3094d77d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094d77d",
  null
  
)

export default component.exports